/* ========================================================= 
   KEY API HELPER (E2EE PRIVATE KEY BACKUP)
   - Handles server communication ONLY
   - No crypto logic here
========================================================= */

import axios from "axios";

/* =========================================================
   GET PRIVATE KEY (restore from server)
========================================================= */
export const fetchPrivateKeyBackup = async () => {
  try {
    const res = await axios.get("/api/keys/private-key", {
      withCredentials: true,
    });

    // ✅ Return FULL payload (like auth.js)
    return res.data;

  } catch (err) {
  ;
    return null; // ✅ match auth.js behavior
  }
};

/* =========================================================
   STORE PRIVATE KEY (backup to server)
========================================================= */
export const storePrivateKeyBackup = async (payload) => {
  try {
    await axios.post(
      "/api/keys/private-key",
      payload, // ✅ send full payload as-is
      { withCredentials: true }
    );

    return true;

  } catch (err) {
  
    return false;
  }
};

/* =========================================================
   GET PEER PUBLIC KEY (fallback / direct fetch)
========================================================= */
export const fetchPeerPublicKey = async (chatId) => {
  try {
    if (!chatId) return null;

    const res = await axios.get(`/api/keys/public-key/${chatId}`, {
      withCredentials: true,
    });

    return res.data?.publicKey || null;

  } catch (err) {
 
    return null;
  }
};


/* =========================================================
   🔐 USWD SIGNING KEYS
========================================================= */

/**
 * Restore USWD signing private key backup
 */
export const fetchSigningKeyBackup =
async () => {

  try {

    const res =
      await axios.get(
        "/api/keys/uswd-signing-backup",
        {
          withCredentials: true,
        }
      );

    return res.data;

  } catch (err) {


    return null;

  }

};


/**
 * Store USWD signing private key backup
 */
export const storeSigningKeyBackup =
async (payload) => {

  try {

    await axios.post(
      "/api/keys/uswd-signing-backup",
      payload,
      {
        withCredentials: true,
      }
    );

    return true;

  } catch (err) {


    return false;

  }

};


/**
 * Fetch peer USWD signing public key
 */
export const fetchPeerSigningPublicKey =
async (chatId) => {

  try {

    if (!chatId) {
      return null;
    }

    const res =
      await axios.get(
        `/api/keys/uswd-public-key/${chatId}`,
        {
          withCredentials: true,
        }
      );

    return (
      res.data?.publicKey ||
      null
    );

  } catch (err) {


    return null;

  }

};

/* =========================================================
   GET WRAPPED STATUS KEY
   (ECDH wrapped by server for this follower)
========================================================= */

export const fetchStatusKey =
async (ownerChatId) => {

  try {

    if (!ownerChatId) {
      return null;
    }

    const res =
      await axios.get(

        `/api/keys/status-key/${ownerChatId}`,

        {
          withCredentials: true,
        }

      );

    return res.data;

  } catch (err) {


    return null;

  }

};

/* =========================================================
   ◎ USDT WALLET BACKUP
========================================================= */

/**
 * Restore USDT wallet backup
 */
export const fetchUsdtWalletBackup =
async () => {

  try {

    const res =
      await axios.get(
        "/api/keys/usdt-wallet-backup",
        {
          withCredentials: true,
        }
      );

    return res.data;

  } catch (err) {

    return null;

  }

};


/**
 * Store USDT wallet backup
 */
export const storeUsdtWalletBackup =
async (payload) => {

  try {

    await axios.post(
      "/api/keys/usdt-wallet-backup",
      payload,
      {
        withCredentials: true,
      }
    );

    return true;

  } catch (err) {

    return false;

  }

};
